export function getMeasurementBoundingClientRect(el: HTMLElement): DOMRect {
  return el.getBoundingClientRect();
}
